// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "app/styles/" + chunkId + "." + {"787":"bbb46c34200d42475a24","1034":"f984c5e36710114b5744"}[chunkId] + ".css";
};